import * as types from "../../mutation-types";
import statistika from "./statistika";
import prijem from "./prijem";
import check from "./check";
import pretraga from "./pretraga";
import uputnice from "./uputnice";
import obrada from "./obrada";
import izvjestaj from "./izvjestaj";
import nalazi from "./nalazi";
import worklist from "./worklist";
import reports from "./reports";
import dbpatients from "./dbpatients";
import dbracuni from "./dbracuni";
import analize from "./analize";
import help from "./help";
import kontrole from "./kontrole";
import inventar from "./inventar";
import thermometer from "./loger";
import mikrobiologija from "./mikrobiologija";
import partneri from "./partneri";
import postavke from "./postavke";
import ustanove from "./ustanove";
import ljekari from "./ljekari";
import integracija from "./integracija";
import excel from "./excel";
import analysers from "./analysers";
import assays from "./assays";

const state = {
  items: [
    statistika, // Statistika
    prijem, // Prijem pacijenta
    check, // Prijem uzorka
    uputnice, // Uputnice
    pretraga, // Pretraga
    obrada, // Obrada
    mikrobiologija, // Mikrobiologija
    izvjestaj, // Predračun
    nalazi, // Nalazi
    worklist, // Radni list
    reports, // Izvještaji
    dbpatients, // DB Pacijenti
    dbracuni, // // DB Predračuni
    ustanove, // Ustanove
    ljekari, // Ljekari
    analize, // Analize
    help, // Informacije
    inventar, // Inventar
    kontrole, // Kontrole
    excel, // Import
    integracija, // Integracija
    thermometer, // Temperatura
    partneri, // Partneri
    postavke, // Postavke
    analysers, // Analizatori
    assays, // Assays
  ]
};

const mutations = {
  [types.TOGGLE_EXPAND_MENU_ITEM](state, payload) {
    let menuItem = payload.menuItem;
    let expand = payload.expand;
    if (menuItem.children && menuItem.meta) {
      menuItem.meta.expanded = expand;
    }
  }
};

const actions = {
  toggleExpandMenuItem({ commit }, payload) {
    commit(types.TOGGLE_EXPAND_MENU_ITEM, payload);
  }
};

export default {
  state,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/menu/index.js